<script>
  import { LayerCake, Svg } from "layercake";
  import AxisX from "./AxisX.svelte";
  import Line from "./track_line.svelte";
  import Box from "./track_container.svelte"; 

  export let msoaLabel = "Your area";
  export let msoa = 0;
  export let la = 0;
  export let region = 0;
  export let country = 0;
  export let maxVal = 0;
  export let formatTick = d => d + "%";

  export let lines = [{
    l: 275,
    area: "Your area",
    fill: "#f00"
  },{
    l: 386.67,
    area: "Your region",
    fill: "#0f0"
  },{
    l: 986.78,
    area: "England",
    fill: "#00f"
  }];

  $: getLines = () => {
    if(msoa !== 0) {
      lines = [{
        l: la.replace("%", ""),
        v: la.replace("%", ""),
        fill: "#E6B217",
      },{
        l: region.replace("%", ""),
        v: region.replace("%", ""),
        fill: "#0063E6",
      },{
        l: country.replace("%", ""),
        v: country.replace("%", ""),
        fill: "#c1002a",
      },{
        l: msoa.replace("%", ""),
        v: msoa.replace("%", ""),
        area: msoaLabel,
        fill: "#7ec850",
      }];
    }

    return lines;
  }

  

  $: data = getLines();

  const padding = {top: 0, bottom: 20, left: 20, right: 20};

  $: maxVal = maxVal > 0 ? maxVal : data.map(d => d.v).sort((a, b) => b - a)[0];

</script>

<div class="track" aria-hidden="true">
  <LayerCake
    {padding}
    x="l"
    y="area"
    xDomain={[0, maxVal]}
    {data}
  >
    <Svg>
      <Box />
      <Line />
      <AxisX stroke="#000" tickNumber={5} gridlines={true} {formatTick} />
    </Svg>
  </LayerCake>
</div>

<style>
  .track {
    height: 40px;
  }
</style>